import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const DiamondArrowCurveUpIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M8.13056 7.28555L2 13.3679L8.14002 19.4409L14.28 13.3679L8.13056 7.28555ZM4.67739 13.3679L8.14002 9.93779L11.5932 13.3679L8.13056 16.798L4.67739 13.3679ZM19.5024 7.5011C17.8467 5.85166 15.6613 5.02693 13.4853 5.02693V1.99045L9.47398 5.96412L13.4853 9.93779V6.9013C15.1788 6.9013 16.8723 7.53859 18.1684 8.82254C20.7512 11.3811 20.7512 15.5422 18.1684 18.1007C16.8723 19.3846 15.1788 20.0219 13.4853 20.0219C12.5676 20.0219 11.65 19.8251 10.7985 19.4502L9.38884 20.8466C10.666 21.5402 12.0757 21.8963 13.4853 21.8963C15.6613 21.8963 17.8467 21.0716 19.5024 19.4221C22.8325 16.1326 22.8325 10.7906 19.5024 7.5011Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
